<template lang="pug">
.backBox
  .titleClose
    span 设置
    van-icon(name='cross' @click='closeAdd' color='#fff' size='20px')
  .backColor
    span 背景色
    ul
      li.colorLeft(@click="setBackColor('#212830',1)" :class='{activeColor:backColorCurrent == 1}')
      li.colorCenter(@click="setBackColor('#B0D8FF',2)" :class='{activeColor:backColorCurrent == 2}')
      li.colorRight(@click="setBackColor('#FFFFFF',3)" :class='{activeColor:backColorCurrent == 3}')
  .light
    span 屏幕常亮
    el-switch(v-model='lightChecked' active-value='true' inactive-value='false' active-color='var(--theme-color)' inactive-color='#dcdfe6' @change='changeLight')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data() {
    return {
      headTitle: "",
      setArea: true,
      lightChecked: "true",
      backColorCurrent: "",
      background: ''
    };
  },
  mounted() {
    this.lightChecked = this.$route.query.screenLight;
  },
  methods: {
    // 背景色修改
    setBackColor(color, val) {
      this.backColorCurrent = val;
      mongeApiMlib.set2DBgc(color);
    },
    // app图纸是否常亮
    changeLight(val) {
      const light = val == "true";
      var data = { source: "light", light };
      mongeApiMlib.uniPostMessage(data);
    },
    closeAdd() {
      this.$emit("closeCom", 'set', false);
    }
  }
};
</script>

<style lang="scss" scoped>
  .backBox {
    width: calc(100% - 40px);
    height: 228px;
    position: absolute;
    left: 20px;
    top: calc(50% - 114px);
    z-index: 4;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.68);
    .titleClose {
      height: 47px;
      line-height: 47px;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.35);
      span {
        font-size: 17px;
        color: #ffffff;
      }
    }
    .backColor {
      width: 100%;
      height: 64px;
      margin-top: 29px;
      padding-left: 13px;
      span {
        width: auto;
        height: 20px;
        font-size: 15px;
        color: #ffffff;
        float: left;
      }
      ul {
        width: auto;
        height: 48px;
        margin-top: 20px;
        display: flex;
        justify-content: space-around;
        li {
          width: 22px;
          height: 22px;
          float: left;
          border-radius: 50%;
          border: 1px solid #fff;
        }
        .colorLeft {
          background: #212830;
        }
        .colorCenter {
          background: #b0d8ff;
        }
        .colorRight {
          background: #ffffff;
        }
        .activeColor {
          border: 2px solid var(--theme-color);
        }
      }
    }

    .light {
      width: 100%;
      height: 44px;
      padding-left: 13px;
      display: flex;
      align-items: center;
      /deep/ .van-switch--on {
        background: var(--theme-color);
      }
      span {
        height: 20px;
        font-size: 15px;
        color: #ffffff;
        float: left;
        margin-right: 35px;
      }
    }
  }
</style>
